import React from 'react'

import { reverse } from 'named-urls'

import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Divider,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  Switch,
  makeStyles,
  Tooltip,
  IconButton,
} from '@material-ui/core'

import { ExpandMore, Edit, Help } from '@material-ui/icons'

import helpers from 'helpers'
import { Permitted } from 'components/Permissions'

import { routes } from 'routes'
import styles from './styles'
import { LogIconButton } from 'components/Logs'

const useStyles = makeStyles(styles)

const TableRowEmail = ({ email, onStatusChange, onClickEdit }) => {
  const classes = useStyles()

  const hasQuantityDaysToDueDate = helpers.emails.hasQuantityDaysToDueDate(
    email,
  )
  const textQuantityDaysToDueDate = helpers.emails.formatQuantityDaysToDueDate(
    email,
  )

  return (
    <TableRow hover>
      <TableCell>
        <div className={classes.title}>
          {email.mappedEmail.title}
          <Tooltip title={email.mappedEmail.description} placement="top">
            <Help color="action" className={classes.helpIcon} />
          </Tooltip>
        </div>
      </TableCell>
      <TableCell>
        {hasQuantityDaysToDueDate && (
          <>
            <Typography variant="body2" display="inline">
              {textQuantityDaysToDueDate}:{' '}
            </Typography>
            <Typography display="inline">
              {email.variables.quantityDaysToDueDate}
            </Typography>
          </>
        )}
      </TableCell>
      <TableCell align="right">
        <LogIconButton
          to={reverse(routes.settings.emails.logs, {
            emailId: email.id,
          })}
        />
        <Permitted tag="edit_email">
          {hasQuantityDaysToDueDate && (
            <Tooltip title="Editar">
              <IconButton onClick={() => onClickEdit(email)}>
                <Edit />
              </IconButton>
            </Tooltip>
          )}

          <Switch
            checked={email.active}
            onChange={event => onStatusChange(event, email)}
          />
        </Permitted>
      </TableCell>
    </TableRow>
  )
}

const InvoiceCollapse = ({ emails, onStatusChange, onClickEdit }) => {
  const classes = useStyles()

  return (
    <ExpansionPanel>
      <ExpansionPanelSummary expandIcon={<ExpandMore />}>
        <Typography variant="h6">Faturas</Typography>
      </ExpansionPanelSummary>

      <Divider />

      <ExpansionPanelDetails className={classes.expansionPanelDetails}>
        <Table>
          <TableBody>
            {emails.map(email => (
              <TableRowEmail
                email={email}
                key={email.id}
                onStatusChange={onStatusChange}
                onClickEdit={onClickEdit}
              />
            ))}
          </TableBody>
        </Table>
      </ExpansionPanelDetails>
    </ExpansionPanel>
  )
}

export default InvoiceCollapse
